import type { NotificationFormType, Notifications } from '@/notificationForms'

import { useMemo } from 'react'

import { form } from '../../../../formState'

export function useMessageSettings(notification: NotificationFormType) {
  // includeMessageUnsubscriptionInstructions
  const includeMessageUnsubscriptionInstructionsEmail = form.useFormField(
    'includeMessageUnsubscriptionInstructionsEmail',
  ).field.value

  const includeMessageUnsubscriptionInstructionsPhone = form.useFormField(
    'includeMessageUnsubscriptionInstructionsPhone',
  ).field.value

  const notificationWay = form.useFormField('notificationWay').field.value

  const includeMessageUnsubscriptionInstructions =
    notificationWay === 'EMAIL'
      ? includeMessageUnsubscriptionInstructionsEmail
      : includeMessageUnsubscriptionInstructionsPhone

  // // includeMessageTrackingLink
  const includeMessageTrackingLink = form.useFormField('includeMessageTrackingLink').field.value

  // // templateDefaultLimits
  const templateDefaultLimits = form.useFormField('templateDefaultLimits').field.value

  // // templateCustomLimits
  const templateCustomLimits = form.useFormField('templateCustomLimits').field.value

  const notificationType = useMemo(() => `${notification}Settings` as Notifications, [notification])
  const notificationLimits = useMemo(() => {
    return {
      ...templateDefaultLimits,
      ...templateCustomLimits,
    } as uui.domain.client.rm.NotificationTemplateLimits
  }, [templateDefaultLimits, templateCustomLimits])

  return {
    notificationType,
    notificationLimits,
    includeMessageTrackingLink,
    includeMessageUnsubscriptionInstructions,
  }
}
